/** @format */

import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import cs from "classnames";

const ListBox = ({
  step,
  handleNextStep,
  calculatorType,
  isWagePerHour,
  data,
}) => {
  const [listItems, setListItems] = useState<any>([]);
  const step1 = () => {
    switch (calculatorType) {
      case "calc-1":
        return "What is your listing price?";
      case "calc-2":
        return "What is the desired profit per product?";
      case "calc-3":
        return "What is your listing price?";
    }
  };
  const listItems123 = [
    { text: step1() },
    {
      text:
        calculatorType === "calc-3"
          ? "What is the desired profit per product?"
          : "What is the dollar value of each hour of your time spent?",
    },
    { text: "How much time did you spend producing the product?" },
    { text: "What did this product cost you to make and ship?" },
    { text: "What fees were paid to marketplaces?" },
  ];
  const listItems4 = [
    { text: "What is your listing price?" },
    {
      text: "How much time did you spend producing the product, packaging, and shipping it? ",
    },
    { text: "What did this product cost you to make and ship? " },
    { text: "What fees were paid to service providers? " },
  ];

  const listItems5 = [
    { text: "What did this product cost you to make and ship?" },
    {
      text: "What fees were paid to service providers?",
    },
    { text: "What is your listing price? " },
  ];

  useEffect(() => {
    if (calculatorType === "calc-5") {
      return setListItems(listItems5);
    }
    if (calculatorType === "calc-4") {
      return setListItems(listItems4);
    }
    return setListItems(listItems123);
  }, [calculatorType]);
  return (
    <Col lg={5} md={6} className="desktop">
      <div className="real-time-calculator-info-box">
        <h6 className="modal-sub-title mb-1">
          {calculatorType === "calc-1" && (
            <div>
              <p className="project-title">
                Your profit for one product would be
              </p>
              <p className="project-amount">
                <span className="font-bold"> $</span>
                {data.profit || "0.00"}
              </p>
            </div>
          )}
          {calculatorType === "calc-2" && (
            <div>
              <p className="project-title">You should list your product at</p>
              <p className="project-amount">
                <span className="font-bold"> $</span>
                {data.listingPrice || "0.00"}
              </p>
            </div>
          )}
          {calculatorType === "calc-3" && (
            <div>
              <p className="project-title">You should value your time at</p>
              <p className="project-amount">
                <span className="font-bold"> $</span>
                {data.lcost || "0.00"}
              </p>
            </div>
          )}
          {calculatorType === "calc-4" && (
            <div>
              <p className="project-title">You earn an average of</p>
              <p className="project-amount">
                <span className="font-bold"> $</span>
                {data.averagePerHour || "0.00"} / hour
              </p>
            </div>
          )}
          {calculatorType === "calc-5" && (
            <>
              <div>
                <p className="project-title">Your profit margin is</p>
                <p className="project-amount">{data.netProfitMargin || 0}%</p>
                <br />
                <p className="project-title">Your net profit is</p>
                <p className="project-amount">
                  <span className="font-bold"> $</span>
                  {data.netProfit || "0.00"}
                </p>
              </div>
            </>
          )}
        </h6>

        {/*<p className="project-title">Current projected profit</p>*/}
        {/*<p className="project-amount">$24.55</p>*/}
      </div>
      <ul className="list-link">
        {listItems.map((item, i) => {
          let index = i;
          if (isWagePerHour) {
            if (i > 0) index = i + 1;
          }
          return (
            <li
              className={cs("d-flex align-items-center", {
                ["active-links"]: step === index + 1,
              })}
              onClick={() => handleNextStep({ step: index + 1 })}
              key={item.text}
            >
              <span>{i + 1}</span>
              {item.text}
            </li>
          );
        })}
      </ul>
    </Col>
  );
};
export default ListBox;
